module.exports = __webpack_public_path__ + "assets/img/001.20211ad4.png";